
// @ts-nocheck



import { i18nText } from '@/locales';

import Vue from 'vue';
import Component from 'vue-class-component';
import {ITableColumn} from '@/entity/table/table.types';


@Component
export class TableColumns extends Vue {
    get certificate_col(): ITableColumn[] {
        return [
            {
                title: i18nText("Номер"),
                dataIndex: 'code',
                scopedSlots: {
                    filterDropdown: "filterDropdown",
                    filterIcon: "filterIcon",
                    customRender: "codeSlot",
                },
            },
            /*{
                title: 'Клиент',
                dataIndex: 'client_name',
                scopedSlots: {
                    filterDropdown: "filterDropdown",
                    filterIcon: "filterIcon",
                    customRender: "client_link",
                },
            },*/
            {
                title: i18nText("Тип"),
                dataIndex: 'type_name',
                scopedSlots: {
                    filterDropdown: "filterDropdown",
                    filterIcon: "filterIcon",
                    customRender: "type_link",
                },
            },
            {
                title: i18nText("Номинал"),
                // dataIndex: 'balance',
                dataIndex: 'type_balance',
                customRender: (data) => {

                    return data;

                },
                scopedSlots: {
                    filterDropdown: "filterDropdown",
                    filterIcon: "filterIcon",
                },
            },
            {
                title: i18nText("Дата активации"),
                dataIndex: 'active_from',
                scopedSlots: {
                    filterDropdown: "filterDropdown",
                    filterIcon: "filterIcon",
                },
            },
            {
                title: i18nText("Дата сгорания"),
                dataIndex: 'active_to',
                scopedSlots: {
                    filterDropdown: "filterDropdown",
                    filterIcon: "filterIcon",
                },
            },
            {
                title: i18nText("Статус"),
                dataIndex: 'active',
                scopedSlots: {
                    filterDropdown: "filterDropdown",
                    filterIcon: "filterIcon",
                    customRender: "statusSlot",
                },
            },
            {
                title: i18nText("Остаток"),
                // dataIndex: 'amountInStock',
                dataIndex: 'balance',
                customRender: (data) => {
                    return data;
                },
                scopedSlots: {
                    filterDropdown: "filterDropdown",
                    filterIcon: "filterIcon",
                    //customRender: "statusSlot",
                },
            },
        ]
    }

    get certificateType_col(): ITableColumn[] {
        return [
            {
                title: i18nText("Название"),
                dataIndex: "name",
                scopedSlots: {
                    filterDropdown: "filterDropdown",
                    filterIcon: "filterIcon",
                    customRender: "nameCertificate"
                },
            },
            {
                title: i18nText("Выпущено"),
                dataIndex: "created",
                scopedSlots: {
                    filterDropdown: "filterDropdown",
                    filterIcon: "filterIcon",
                },
            },
            {
                title: i18nText("Тип списания"),
                dataIndex: "writeoff_id",
                customRender: data => data == 1 ? i18nText("Однократное") : i18nText("Многократное"),
                scopedSlots: {
                    filterDropdown: "filterDropdown",
                    filterIcon: "filterIcon",
                },
            },
            {
                title: i18nText("Номинал"),
                dataIndex: "balance",
                // customRender: async data => {


                //     // return await (data.toString().replace(/\..+$/gmi, '') + currencyOfThisStudioString);
                // },
                scopedSlots: {
                    filterDropdown: "filterDropdown",
                    filterIcon: "filterIcon",
                },
            },
        ]
    }

    get subscription_col(): ITableColumn[] {
        return [
            {
                title: "",
                key: "edit",
                dataIndex: "edit",
                scopedSlots: {
                    customRender: "edit",
                }
            },
            {
                title: i18nText("Номер"),
                key: "membership_number",
                dataIndex: "membership_number",
                scopedSlots: {
                    filterDropdown: "filterDropdown",
                    filterIcon: "filterIcon",
                    customRender: "name",
                },
            },
            {
                title: i18nText("Тип"),
                key: "type_name",
                dataIndex: "type_name",
                scopedSlots: {
                    filterDropdown: "filterDropdown",
                    filterIcon: "filterIcon",
                    customRender: "type.name",
                },
            },
            {
                title: i18nText("Баланс"),
                key: "balance",
                dataIndex: "balance",
                customRender: (data) => {
                    var returnStr = '';
                    data.forEach((element, i) => {
                        if (element.name !== undefined && element.quantity !== undefined) {
                            returnStr += `${element.name} X ${element.quantity}` + ((i + 1) == data.length ? '' : ', ');
                        }
                    });

                    if(!returnStr) {
                        returnStr = i18nText("Нет привязанных услуг");
                    }

                    return returnStr;
                },
                scopedSlots: {
                    filterDropdown: "filterDropdown",
                    filterIcon: "filterIcon",
                },
            },
            {
                title: i18nText("Статус"),
                key: "status",
                dataIndex: "status.name",
                scopedSlots: {
                    customRender: 'status.name',
                    filterDropdown: "filterDropdown",
                    filterIcon: "filterIcon",
                },
            },
            {
                title: i18nText("Действует до"),
                key: "active_to",
                dataIndex: "active_to",
                scopedSlots: {
                    customRender: 'active_to',
                    filterDropdown: "filterDropdown",
                    filterIcon: "filterIcon",
                }
            },
            {
                title: i18nText("Покупатель"),
                key: "client_phone",
                dataIndex: "client_phone",
                scopedSlots: {
                    filterDropdown: "filterDropdown",
                    filterIcon: "filterIcon",
                },
            },
            {
                title: i18nText("Продажа"),
                key: "created_at",
                dataIndex: "created_at",
                scopedSlots: {
                    customRender: 'created_at',
                    filterDropdown: "filterDropdown",
                    filterIcon: "filterIcon",
                },
            },
            {
                title: i18nText("Дата активации"),
                key: "active_from",
                dataIndex: "active_from",
                scopedSlots: {
                    customRender: 'active_from',
                    filterDropdown: "filterDropdown",
                    filterIcon: "filterIcon",
                }
            },
            {
                title: i18nText("Стоимость"),
                key: "type_price",
                dataIndex: "type_price",
                scopedSlots: {
                    filterDropdown: "filterDropdown",
                    filterIcon: "filterIcon",
                },
            },
            {
                title: i18nText("Списания"),
                key: "transactions_sum",
                dataIndex: "transactions_sum",
                scopedSlots: {
                    filterDropdown: "filterDropdown",
                    filterIcon: "filterIcon",
                },
            },

            {
                title: i18nText("Сумма"),
                key: "total_sum",
                dataIndex: "total_sum",
                scopedSlots: {
                    filterDropdown: "filterDropdown",
                    filterIcon: "filterIcon",
                },
            },
        ]
    }


    get subscriptionType_col(): ITableColumn[] {
        return [
            {
                title: i18nText("Название "),
                dataIndex: 'name',
                scopedSlots: {
                    filterDropdown: "filterDropdown",
                    filterIcon: "filterIcon",
                    customRender: "name",
                },
            },
            {
                title: i18nText("Выпущено"),
                dataIndex: 'created',
                scopedSlots: {
                    filterDropdown: "filterDropdown",
                    filterIcon: "filterIcon",
                },
            },
            {
                title: i18nText("Стоимость"),
                dataIndex: 'price',
                scopedSlots: {
                    filterDropdown: "filterDropdown",
                    filterIcon: "filterIcon",
                },
            },
            {
                title: i18nText("Срок действия (месяцев)"),
                dataIndex: 'validity',
                scopedSlots: {
                    filterDropdown: "filterDropdown",
                    filterIcon: "filterIcon",
                },
            },
        ]
    }
}
